/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterOSmall = createReactComponent("letter-o-small", "IconLetterOSmall", [
  [
    "path",
    {
      d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z",
      key: "svg-0"
    }
  ]
]);

export { IconLetterOSmall as default };
//# sourceMappingURL=IconLetterOSmall.js.map
